
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wheels/pickup",
      function () {
        return require("private-next-pages/wheels/pickup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wheels/pickup"])
      });
    }
  